import {
  InlineLinkClickHandler,
  InlineLinkProps,
} from './InlineLinkClickHandler';
import {MarkdownText} from './MarkdownText';

export const LinkableMarkdownText = ({
  body,
  onLinkClick,
}: {
  body: string;
  onLinkClick: (props: InlineLinkProps) => boolean | void;
}) => {
  return (
    <InlineLinkClickHandler onClick={onLinkClick}>
      <MarkdownText body={body} />
    </InlineLinkClickHandler>
  );
};
